export default __webpack_public_path__ + "locales/hy-AM/FilesSettings.json?hash=5a367f10c48115ceeb4497970a72db01";